import { CompanyConfirmStructure } from '../components';
import { useCompanyConfirmStructure } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyConfirmStructureStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    files,
    initialValues,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    submitDisabled,
    submitLoading,
    goToBack,
  } = useCompanyConfirmStructure();

  return (
    <CompanyConfirmStructure
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
